import { Box } from '@mui/material';

import { Bottom, CandidateFeedbackRowContainer, Top, TopLeft } from '../../../styles/styles';
import { ReviewerAndCompletionStatus } from './ReviewerAndCompletionStatus';
import { CandidateFeedbackRowProps } from '../../../types/feedbackDetailTypes';
import { CompletionChip } from './CompletionChip';
import { RowCTA } from './RowCTA';
import { TemplateAndVisibility } from './TemplateAndVisibility';
import { FeedbackStatus } from '../../Statuses/components/FeedbackStatus';
import { ATSConnectHiringRequestCandidateFeedbackTestIds } from 'data-testids/ATS';
import { getCompletionText } from '../../../utils';
import auth from 'utils/auth';

export const CandidateFeedbackRow: React.FC<CandidateFeedbackRowProps> = ({
  data,
  onViewClick,
  onEditClick,
  modalType,
}) => {
  const { created } = data;
  const user = auth.getUser();
  const currentUserUserName = user?.username;
  const scorecardAuthor =
    typeof data?.submitted_by === 'object' ? data.submitted_by.email : data?.submitted_by;
  const isAuthor = currentUserUserName === scorecardAuthor;

  const isReferenceCheck = modalType === 'reference' && 'is_complete' in data;
  const isScorecard = modalType === 'scorecard' && 'scorecard_complete' in data;
  const isComplete = 'scorecard_complete' in data ? data.scorecard_complete : data.is_complete;
  const templateName = 'template' in data ? data.template.title : data.template_name;
  const id = 'hiring_request_id' in data ? data.hiring_request_id : data.reference_id;

  const completionText = getCompletionText(isComplete, data.created);
  const hasRecommendation = data.final_recommendation && data.show_answer_on_preview;
  const hasScore = data.cumulative_score && data.show_total_on_preview;
  const isPendingReference = 'message' in data ? Boolean(data.message) : false;

  const getSubmittedByName = () => {
    if ('hiring_request_id' in data) {
      return data.submitted_by.name;
    } else {
      if ('recipients' in data) {
        return data.recipients[0].name;
      } else {
        return data.submitted_by_name;
      }
    }
  };

  return (
    <CandidateFeedbackRowContainer
      data-testid={ATSConnectHiringRequestCandidateFeedbackTestIds.MODAL_ROW}
    >
      <Top>
        <TopLeft>
          <CompletionChip
            modalType={modalType}
            isComplete={isComplete}
            isPending={isPendingReference}
          />
          <Box sx={{ width: '100%' }}>
            <ReviewerAndCompletionStatus
              date={created}
              isComplete={isComplete}
              submittedByName={getSubmittedByName()}
            />

            <Bottom>
              {isComplete && (
                <FeedbackStatus
                  hasRecommendation={hasRecommendation}
                  hasScore={hasScore}
                  completionText={completionText}
                  cumulativeScore={data.cumulative_score}
                  maxCumulativeScore={data.max_cumulative_score}
                  finalRecommendation={data.final_recommendation}
                  showTotalOnPreview={data.show_total_on_preview}
                />
              )}
              <TemplateAndVisibility
                templateName={templateName}
                isDraft={
                  (isReferenceCheck && !data.is_complete) ||
                  (isScorecard && !data.scorecard_complete)
                }
              />
            </Bottom>
          </Box>
        </TopLeft>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <RowCTA
            id={id}
            isComplete={isComplete}
            onEditClick={onEditClick}
            onViewClick={onViewClick}
            collectionId={data.id}
            modalType={modalType}
            isAuthor={isAuthor}
            isPending={isPendingReference}
          />
        </Box>
      </Top>
    </CandidateFeedbackRowContainer>
  );
};
